import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Annuaire from "../pages/Annuaire";

// annuaire
export const annuaireRoutes = (
    <Route path={ROUTES.annuaire} element={<Annuaire />} key="annuaire" />
);
